module.exports = __webpack_public_path__ + "static/media/linkedin-icon.54f06be9.svg";